



















































import {Vue, Component} from 'vue-property-decorator';
import DateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import DateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import {FilterDataType} from '@/types/product';
import {momentAdd} from '@/utils/dateUtils';
import {toI18n} from '@/utils/commonUtils';
import {AllFilterDateMapping} from '@/types/product';
import {changeDateFormat} from '@/utils/dateUtils';

@Component({
  components: {
    DateRangePicker,
    DateFilterBtns
  }
})
export default class ModifySalePeriod extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private today: string = changeDateFormat('', 'YYYY-MM-DD');
  private initRangeStartYmd = this.today;
  private filterDateData: FilterDataType[] = [
    {value: '3d', label: this.toI18n('DAYS_3'), selected: false},
    {value: '7d', label: this.toI18n('DAYS_7'), selected: false},
    {value: '15d', label: this.toI18n('DAYS_15'), selected: false},
    {value: '30d', label: this.toI18n('DAYS_30'), selected: false},
    {value: '60d', label: this.toI18n('DAYS_60'), selected: false},
    {value: '90d', label: this.toI18n('DAYS_90'), selected: false}
  ];

  private get currentDateRange(): string {
    const selectVal: FilterDataType = this.filterDateData.find((data: FilterDataType): any => data.selected) || {
      value: '0',
      label: toI18n('BOARD_FAQ_TODAY'),
      selected: true
    };
    return selectVal.value;
  }

  private get mallProductNos(): string[] {
    return this.$route.params.mallProductNos.split(',');
  }

  private get startYmdt(): string {
    return `${this.dateReceiveData.startYmd} ${this.timeReceiveData.startTime}`;
  }

  private get endYmdt(): string {
    return `${this.dateReceiveData.endYmd} ${this.timeReceiveData.endTime}`;
  }

  private salePeriodInfo = {
    startYmdt: '',
    endYmdt: '',
    periodType: 'REGULAR'
  };

  private saleStatusType = '';

  private filterDateMapping: AllFilterDateMapping = {
    '3d': [3, 'd'],
    '7d': [7, 'd'],
    '15d': [15, 'd'],
    '30d': [30, 'd'],
    '60d': [60, 'd'],
    '90d': [90, 'd']
  };

  private dateData: {startYmd: string; endYmd: string} = {
    startYmd: this.today,
    endYmd: momentAdd(this.today, this.filterDateMapping['90d'], 'YYYY-MM-DD')
  };

  private dateReceiveData = {...this.dateData};

  private timeData: {startTime: string; endTime: string} = {
    startTime: '00:00',
    endTime: '23:59'
  };
  private timeReceiveData = {...this.timeData};

  private disabledData = {
    start: true,
    end: true
  };

  private setEndYmd(): void {
    this.dateData = {...this.dateReceiveData};
    Object.assign(this.dateData, {
      startYmd: this.dateReceiveData.startYmd,
      endYmd: momentAdd(this.dateReceiveData.startYmd, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD')
    });
  }

  private setFilterUnSelected(): void {
    const oldIdx = this.filterDateData.findIndex((item: FilterDataType): any => item.selected);
    this.$set(this.filterDateData, oldIdx, {...this.filterDateData[oldIdx], selected: false});
  }

  private dateFilterChange(idx: number): void {
    this.setFilterUnSelected();
    this.$set(this.filterDateData, idx, {...this.filterDateData[idx], selected: true});
    this.setEndYmd();
  }

  private dateDataChange({startYmd, endYmd, isBtnSet}: any): void {
    if (!isBtnSet) {
      this.setFilterUnSelected();
    }
    this.dateReceiveData = {startYmd, endYmd};
  }

  private timeDataChange({startTime, endTime}: any): void {
    this.timeReceiveData = {startTime, endTime};
  }

  private initStatus() {
    this.initRangeStartYmd = this.salePeriodInfo.startYmdt.substring(0, 10);
    this.dateData = Object.assign(
      {},
      {
        startYmd: this.salePeriodInfo.startYmdt.substring(0, 10),
        endYmd: this.salePeriodInfo.endYmdt.substring(0, 10)
      }
    );

    this.timeData = Object.assign(
      {},
      {
        startTime: this.salePeriodInfo.startYmdt.substring(11, 16),
        endTime: this.salePeriodInfo.endYmdt.substring(11, 16)
      }
    );
  }

  private periodTypeChange() {
    const periodType = this.salePeriodInfo.periodType;

    if (periodType === 'REGULAR') {
      if (this.mallProductNos.length === 1) {
        //saleStatusType:
        //Enum: [ READY: 판매대기, ONSALE: 판매중, FINISHED: 판매종료, STOP: 판매중지, PROHIBITION: 판매금지,
        //RESERVATION_READY: 예약판매대기, RESERVATION_ONSALE: 예약판매중, RESERVATION_FINISHED: 예약판매종료 ]
        if (this.saleStatusType === 'STOP' || this.saleStatusType === 'ONSALE') {
          Object.assign(this.disabledData, {
            start: true,
            end: true
          });
        } else {
          Object.assign(this.disabledData, {
            start: false,
            end: true
          });
        }
      } else {
        Object.assign(this.disabledData, {
          start: true,
          end: true
        });
      }
    } else {
      if (this.mallProductNos.length === 1) {
        if (this.saleStatusType === 'STOP' || this.saleStatusType === 'ONSALE') {
          Object.assign(this.disabledData, {
            start: true,
            end: false
          });
        } else {
          Object.assign(this.disabledData, {
            start: false,
            end: false
          });
        }
      } else {
        Object.assign(this.disabledData, {
          start: false,
          end: false
        });

        Object.assign(this.dateData, {
          startYmd: this.today,
          endYmd: momentAdd(this.today, this.filterDateMapping['90d'], 'YYYY-MM-DD')
        });
      }
    }
  }

  private save() {
    const salePeriodInfo = {
      startYmdt: this.startYmdt + ':00',
      endYmdt: this.endYmdt + ':59',
      periodType: this.salePeriodInfo.periodType
    };

    if (this.salePeriodInfo.periodType === 'REGULAR') {
      delete salePeriodInfo.endYmdt;
    }

    const params = {
      mallProductNos: String(this.mallProductNos)
    };

    this.$api.patchProductsSalePeriod({params, data: {salePeriodInfo}}).then(({data}: any): void => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      window.opener.postMessage({salePeriodInfo: true, data});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup');
    if (this.mallProductNos.length === 1) {
      const params = {
        mallProductNo: Number(this.mallProductNos[0])
      };
      this.$api.getProductByNo({params}).then(({data: {salePeriodInfo, saleStatusType, saleSettingStatusType}}: any) => {
        this.saleStatusType = saleStatusType;
        if (salePeriodInfo) {
          this.salePeriodInfo = salePeriodInfo;
          this.initStatus();

          if ((saleStatusType === 'PRE_APPROVAL_STATUS' || saleStatusType === 'ON_PRE_SALE' || saleStatusType === 'WAITING_SALE') && saleStatusType !== 'ON_SALE') {
            if (new Date(this.initRangeStartYmd).getTime() < new Date().getTime()) {
              this.initRangeStartYmd = this.today;
            }

            Object.assign(this.dateData, {
              startYmd: this.initRangeStartYmd,
              endYmd: '2999-12-31'
            });

            Object.assign(this.disabledData, {
              start: false
            });
          } else if (saleStatusType === 'ON_SALE' || saleSettingStatusType === 'STOP_SELLING') {
            Object.assign(this.disabledData, {
              start: true
            });
          }
        }
      });
    } else {
      this.salePeriodInfo.periodType = 'PERIOD';
      this.periodTypeChange();
    }

    window.name = 'salePeriod';
  }
}
